export default __webpack_public_path__ + "images/7750d1c948255002752d4249f7fd33e7-nye_touchpoint_image.webp";